<template>
  <div>

    <Splide :options="options" :has-track="false">
      <SplideTrack class="md:mx-16 bg-grayLight">
        <SplideSlide v-for="(item, index) in elements" ref="images" class="flex items-center justify-center mx-auto">
          <div>
            <picture class="aspect-[4/3] block">
              <source type="image/webp" :srcset="item.srcWebp">
              <img :src="item.src" :width="item.width" :height="item.height" :alt="item.alt" class="h-full w-auto object-contain object-center mx-auto">
            </picture>
          </div>
        </SplideSlide>
      </SplideTrack>

      <div class="splide__arrows w-full items-center absolute top-1/2 transform -translate-y-1/2">
        <div class="flex justify-between">
          <button
              class="splide__arrow splide__arrow--prev ml-4 md:ml-0 border-2 border-gray rounded-full inline-flex items-center text-center w-12 h-12 justify-center group-hover:bg-gray group-hover:text-white flex-shrink-0">
            <svg class="w-6 h-6 fill-current" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.1816 10.9993C22.7339 10.9993 23.1816 10.5516 23.1816 9.99929C23.1816 9.44701 22.7339 8.99929 22.1816 8.99929L22.1816 10.9993ZM1.81801 9.99929L1.1109 9.29218C0.720375 9.68271 0.720375 10.3159 1.1109 10.7064L1.81801 9.99929ZM9.83817 19.4337C10.2287 19.8242 10.8619 19.8242 11.2524 19.4337C11.6429 19.0431 11.6429 18.41 11.2524 18.0195L9.83817 19.4337ZM11.2524 1.97912C11.6429 1.5886 11.6429 0.955435 11.2524 0.56491C10.8619 0.174386 10.2287 0.174386 9.83817 0.56491L11.2524 1.97912ZM22.1816 8.99929L1.81801 8.99929L1.81801 10.9993L22.1816 10.9993L22.1816 8.99929ZM11.2524 18.0195L2.52511 9.29218L1.1109 10.7064L9.83817 19.4337L11.2524 18.0195ZM2.52511 10.7064L11.2524 1.97912L9.83817 0.56491L1.1109 9.29218L2.52511 10.7064Z"></path></svg>

          </button>
          <button class="splide__arrow splide__arrow--next border-2 mr-4 md:mr-0 border-gray rounded-full inline-flex items-center text-center w-12 h-12 justify-center group-hover:bg-gray group-hover:text-white flex-shrink-0">
            <svg class="w-6 h-6 fill-current" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.81836 9.00071C1.26607 9.00071 0.818359 9.44843 0.818359 10.0007C0.818359 10.553 1.26607 11.0007 1.81836 11.0007L1.81836 9.00071ZM22.182 10.0007L22.8891 10.7078C23.2796 10.3173 23.2796 9.68413 22.8891 9.2936L22.182 10.0007ZM14.1618 0.566331C13.7713 0.175806 13.1381 0.175806 12.7476 0.566331C12.3571 0.956855 12.3571 1.59002 12.7476 1.98054L14.1618 0.566331ZM12.7476 18.0209C12.3571 18.4114 12.3571 19.0446 12.7476 19.4351C13.1381 19.8256 13.7713 19.8256 14.1618 19.4351L12.7476 18.0209ZM1.81836 11.0007L22.182 11.0007V9.00071L1.81836 9.00071L1.81836 11.0007ZM12.7476 1.98054L21.4749 10.7078L22.8891 9.2936L14.1618 0.566331L12.7476 1.98054ZM21.4749 9.2936L12.7476 18.0209L14.1618 19.4351L22.8891 10.7078L21.4749 9.2936Z"></path></svg>
          </button>
        </div>
      </div>


    </Splide>


  </div>
</template>

<script>
import {Splide, SplideSlide, SplideTrack} from '@splidejs/vue-splide';
import {defineComponent, ref} from 'vue';

export default defineComponent({
  name: 'Slider',
  components: {
    Splide,
    SplideSlide,
    SplideTrack
  },
  props: {
    elements: {
      type: Array
    }
  },

  setup() {
    const images = ref([]);
    const options = {
      rewind: true,
      arrows: true,
      pagination: false,
      autoHeight: true,
    };

    return {options, images};
  },
});
</script>